export default __webpack_public_path__ + "static/media/img2.a6b3a67a.jpg";